import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";

export default function FloatingReactions({ sid, onNew }) {
  const [items, setItems] = useState([]);
  const after = useRef(null);
  const first = useRef(true);
  useEffect(() => {
    if (!sid) return;
    let active = true;
    const poll = () => {
      const url = `/live/${sid}/reactions` + (after.current ? `?after=${after.current}` : "");
      api.get(url).then((r) => {
        if (!active || !r.data.length) return;
        after.current = r.data[r.data.length - 1].id;
        if (onNew && !first.current) onNew(r.data.length);
        first.current = false;
        const add = r.data.map((x) => ({ key: x.id + Math.random(), emoji: x.emoji, left: 8 + Math.random() * 82 }));
        setItems((prev) => [...prev, ...add]);
        add.forEach((a) => setTimeout(() => setItems((prev) => prev.filter((i) => i.key !== a.key)), 3400));
      }).catch(() => {});
    };
    poll();
    const t = setInterval(poll, 2000);
    return () => { active = false; clearInterval(t); };
  }, [sid, onNew]);
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" data-testid="floating-reactions">
      {items.map((i) => (
        <span key={i.key} className="absolute bottom-8 text-4xl reaction-float select-none" style={{ left: `${i.left}%` }}>{i.emoji}</span>
      ))}
    </div>
  );
}

export const REACTIONS = ["🙌", "❤️", "🔥", "👏", "🕊️", "🎶"];
